<article class="movie-card" [class.blurred]="isKebabActive">
  <!-- Kebab Menu (Movies & TV) -->
  <div class="kebab-position" *ngIf="showKebab && currentMediaType !== 'person'">
    <app-kebab-component [data]="data" (toggle)="onKebabToggle($event.isActive)"></app-kebab-component>
  </div>

  <!-- Poster Link & Image -->
  <a [routerLink]="detailRoute" class="poster-link">
    <img class="movie-image" [src]="posterUrl" [alt]="displayTitle" width="220" height="330"
      [loading]="priority ? 'eager' : 'lazy'" [attr.fetchpriority]="priority ? 'high' : null" decoding="async"
      (error)="onImageError($event)" />

    <!-- Circular Rating Badge (Movies & TV) -->
    <div class="ratings-container" *ngIf="hasRating">
      <div class="ratings-circle-container">
        <div class="ratings-circle">
          <span class="ratings-text">{{ ratingPercentage }}%</span>
        </div>
      </div>
    </div>
  </a>

  <!-- Content & Info -->
  <div class="content">
    <a [routerLink]="detailRoute" class="movie-name" [title]="displayTitle">
      {{ truncatedTitle }}
    </a>

    <p class="movie-date" *ngIf="displayMeta">
      <i class="far fa-calendar" *ngIf="currentMediaType !== 'person'"></i>
      <i class="fas fa-user-tag" *ngIf="currentMediaType === 'person'"></i>
      <span>{{ displayMeta }}</span>
    </p>
  </div>
</article>